const vehicleAdjustment = () => import('@/pages/vehicleAdjustment/index')
export default [
  {
    path: '/stationOperation/vehicleAdjustment',
    name: 'vehicleAdjustment',
    component: vehicleAdjustment,
    meta: {
      storeKey: 'trs.carDispensing.index'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/vehicleAdjustment/index.js